import { ApiClientError, DomainUser } from '@raydiant/api-client-js';
import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { UseQueryOptions } from 'react-query';

export default function useGetDomainUsers(
  options: UseQueryOptions<DomainUser[], ApiClientError> = {},
) {
  return useProtectedQuery<DomainUser[], ApiClientError>(
    keys.domainUsers(),
    () => raydiant.getDomainUsers(),
    {
      enabled: true,
      ...options,
    },
  );
}
